package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.selection.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.closing_reports.CurrencyTypeEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.CourseEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.Category
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.SetModel
import org.hs_soft.runmynesto.domain.model.home.template.product_categories.TemplateCategoryModel
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.price_level.PriceLevelItem
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.select_days.SelectDays
import org.jetbrains.compose.web.attributes.InputType

@Composable
fun GeneralSelectionInformation(
    windowSizeMode: WindowSizeModeEnum,
    priceLevels: List<String?>?,
    selectedProductSet: SetModel?,
    templateCategories: List<TemplateCategoryModel>?,
    updateSelectedProductSet:(SetModel?)->Unit,
) {
    val updatedSelectedProductSet = remember { mutableStateOf<SetModel?>(null) }
    LaunchedEffect(selectedProductSet) {
        updatedSelectedProductSet.value = selectedProductSet
    }
    val indexedPriceLevelList = priceLevels?.mapIndexed { index, value ->
        PriceLevelItem(value, index)
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        MediumContentTitle(
            title = Strings.current().general,
        )
        Row(
            modifier = Modifier
                .autoResponsiveness()
                .fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            DropDownItem(
                modifier = Modifier
                    .margin(
                        bottom = Dimen.highLargePadding,
                        right = Dimen.largePadding,
                    ),
                options = templateCategories ?: listOf(),
                label = Strings.current().template,
                itemWidth = Dimen.semiLargeEditTextWidth,
                selectedItem = templateCategories?.find {
                    it.id == updatedSelectedProductSet.value?.category?.id
                },
                displayText = {
                    if (it is TemplateCategoryModel)
                        it.name ?: ""
                    else ""
                },
                onOptionClick = {
                    if (it is TemplateCategoryModel) {
                        updatedSelectedProductSet.value = updatedSelectedProductSet.value?.copy(
                            category = Category(
                                id=it.id,
                                name=it.name,
                                typename=null,
                            )
                        )
                        updateSelectedProductSet(updatedSelectedProductSet.value)
                    }
                },
            )

            CustomEditText(
                value = updatedSelectedProductSet.value?.minQuantity?.toString() ?: "",
                marginRight = Dimen.largePadding,
                label = Strings.current().minQuantity,
                inputType = InputType.Number,
                width = Dimen.normalEditTextWidth2,
                isRequired = false,
                onFocusIn = {},
                onFocusOut = {
                    updatedSelectedProductSet.value = updatedSelectedProductSet.value?.copy(
                        minQuantity = it.toIntOrNull()
                    )
                    updateSelectedProductSet(updatedSelectedProductSet.value)
                },
                onInputChange = { newValue, _ ->

                }
            )

            CustomEditText(
                value = updatedSelectedProductSet.value?.maxQuantity?.toString() ?: "",
                marginRight = Dimen.largePadding,
                label = Strings.current().maxQuantity,
                inputType = InputType.Number,
                isRequired = false,
                width = Dimen.normalEditTextWidth2,
                onFocusIn = {},
                onFocusOut = {
                    updatedSelectedProductSet.value = updatedSelectedProductSet.value?.copy(
                        maxQuantity = it.toIntOrNull()
                    )
                    updateSelectedProductSet(updatedSelectedProductSet.value)
                },
                onInputChange = { newValue, _ ->

                }
            )

            SelectDays(
                modifier = Modifier
                    .margin(bottom = Dimen.highLargePadding),
                windowSizeMode = windowSizeMode,
                selectedDaysNumber = updatedSelectedProductSet.value?.weekDays ?: 0,
                onChangeDayCheckStatus = { newDays ->
                    updatedSelectedProductSet.value = updatedSelectedProductSet.value?.copy(
                        weekDays = newDays
                    )
                    updateSelectedProductSet(updatedSelectedProductSet.value)
                }
            )
        }

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .autoResponsiveness(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            DropDownItem(
                modifier = Modifier
                    .margin(bottom = Dimen.highLargePadding),
                itemWidth = Dimen.mediumEditTextWidth,
                options = indexedPriceLevelList ?: listOf(),
                label = Strings.current().priceLevels,
                selectedItem = if (updatedSelectedProductSet.value?.priceLevel != null)
                    indexedPriceLevelList?.find { it.index == updatedSelectedProductSet.value?.priceLevel }
                else null,
                displayText = { item ->
                    if (item is PriceLevelItem) {
                        item.value ?: (LanguageManager.getCurrentStrings().price + " " + item.index.toString())
                    } else ""
                },
                onOptionClick = { item ->
                    if (item is PriceLevelItem) {
                        updatedSelectedProductSet.value = updatedSelectedProductSet.value?.copy(
                            priceLevel = item.index
                        )
                        updateSelectedProductSet(updatedSelectedProductSet.value)
                    }
                },
            )

            CheckboxComponent(
                modifier = Modifier
                    .margin(
                        leftRight = Dimen.largePadding,
                        bottom = Dimen.largePadding
                    ),
                checkStatus = updatedSelectedProductSet.value?.isCollectPoints ?: false,
                onUnChecked = {
                    updatedSelectedProductSet.value = updatedSelectedProductSet.value?.copy(
                        isCollectPoints = false
                    )
                    updateSelectedProductSet(updatedSelectedProductSet.value)
                },
                onChecked = {
                    updatedSelectedProductSet.value = updatedSelectedProductSet.value?.copy(
                        isCollectPoints = true
                    )
                    updateSelectedProductSet(updatedSelectedProductSet.value)
                },
                title = ""
            )

            DropDownItem(
                modifier = Modifier
                    .margin(bottom = Dimen.highLargePadding),
                options = CourseEnum.entries,
                label = Strings.current().course,
                itemWidth = Dimen.semiLargeEditTextWidth,
                selectedItem = CourseEnum.entries.find {
                    it.value == updatedSelectedProductSet.value?.course
                },
                displayText = {
                    if (it is CourseEnum) {
                        it.title ?: ""
                    } else ""
                },
                onOptionClick = { item ->
                    if (item is CourseEnum) {
                        updatedSelectedProductSet.value = updatedSelectedProductSet.value?.copy(
                            course = item.value
                        )
                        updateSelectedProductSet(updatedSelectedProductSet.value)
                    }
                },
            )
        }
    }
}